import Swiper, {Navigation, Pagination, Autoplay} from 'swiper';

(function(window, document, $) {

  jQuery(document).ready(function($) {
    // configure Swiper to use modules
    Swiper.use([Navigation, Pagination, Autoplay]);

    // Swiper slider =================================================================================================

    // Testimonials slider
    function getTestimonialSliderSettings() {
      return {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        speed: 300,
        spaceBetween: 15,
        slidesPerView: 1.2,
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },

        navigation: {
          nextEl: '.wpg-slider-next',
          prevEl: '.wpg-slider-prev',
        },

        pagination: {
          el: '.wpg-slider-pagination',
          type: 'bullets',
          clickable: true,
        },
      };
    }

    const testimonialSlider = new Swiper('.wpg-testimonials-block .wpg-slider-container', getTestimonialSliderSettings());

    // wpg-wdp-top-bar-usps slider
    function getTopBarSliderSettings() {
      return {
            direction: 'horizontal',
            loop: true,
            speed: 300,
            allowTouchMove: false,
            autoplay: {
                delay: 5000,
            },
            enabled: true,
            slidesPerView: 1,
            breakpoints: {
                992: {
                    slidesPerView: 3,
                    enabled: false,
                },
                768: {
                    slidesPerView: 2,
                    enabled: true,
                }
            },
        };
    }

    const topbarSlider = new Swiper('.wpg-top-bar-usps', getTopBarSliderSettings());

    // Gallery slider
    function getGallerySliderSettings() {
      return {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        speed: 300,
        spaceBetween: 15,
        slidesPerView: 1.6,
        breakpoints: {
          992: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },

        navigation: {
          nextEl: '.wpg-slider-next',
          prevEl: '.wpg-slider-prev',
        },

        pagination: {
          el: '.wpg-slider-pagination',
          type: 'bullets',
          clickable: true,
        },
      };
    }

    const gallerySlider = new Swiper('.wpg-gallery-block .wpg-slider-container', getGallerySliderSettings());

    // Articles slider
    function getArticlesSliderSettings() {
      return {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        speed: 300,
        spaceBetween: 15,
        slidesPerView: 1.2,
        breakpoints: {
          992: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
        },

        navigation: {
          nextEl: '.wpg-slider-next',
          prevEl: '.wpg-slider-prev',
        },

        pagination: {
          el: '.wpg-slider-pagination',
          type: 'bullets',
          clickable: true,
        },
      };
    }

    const articlesSlider = new Swiper('.wpg-articles-block .wpg-slider-container', getArticlesSliderSettings());
  });
}(window, document, jQuery));